//
// Module for the GL Transaction Setup detail view
//
rs.module("fund/configuration/gltransactionsetup/transactionsetupdetail",

    ["common/select-helper"],

    function (selectHelper) {

        // Initialize the module
        function initialize(jsSelectors) {
            var form = $.js(jsSelectors.form);
            var defaultFlag = form.js(jsSelectors.defaultFlag);
            var criteria = form.js(jsSelectors.criteria);
            var priorDropCheckbox = criteria.js(jsSelectors.priorDropCheckbox, { required: false });

            defaultFlag.on("change", function () {
                priorDropCheckbox.prop('disabled', defaultFlag[0].checked);
                if (defaultFlag[0].checked) {
                    priorDropCheckbox.checked = false;
                }

                criteria.find('select').each(function () {
                    var helper = selectHelper.getHelper($(this));
                    helper.setDisabled(defaultFlag[0].checked);
                    if (defaultFlag[0].checked) {
                        helper.setValue(null);
                    }
                });
            });

            if (defaultFlag[0].checked) {
                priorDropCheckbox.prop('disabled', true);

                // disabling the selectors here so the data is already loaded if they uncheck the default flag
                criteria.find('select').each(function () {
                    var helper = selectHelper.getHelper($(this));
                    helper.setDisabled(true);
                });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);